// src/layouts/corui/AppContent.jsx
import React, { Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { CContainer, CSpinner } from '@coreui/react'
import routesCore from "../../../routesCore";

const AppContent = () => {
    return (
        <CContainer className="px-4" lg>
            <Suspense fallback={<CSpinner color="primary" />}>
                <Routes>
                    {routesCore.map((route, idx) =>
                            route.element && (
                                <Route
                                    key={idx}
                                    path={route.path.replace('/core/', '')} // ⚠️ Important : rendre le path relatif
                                    element={<route.element />}
                                />
                            )
                    )}
                    {/* Redirection par défaut */}
                    <Route path="*" element={<Navigate to="dashboard" replace />} />
                </Routes>
            </Suspense>
        </CContainer>
    )
}

export default React.memo(AppContent)
